module.exports = __webpack_public_path__ + "assets/img/HOYA.c3c88f07.png";